import React, { useEffect, useState } from "react";
import { useOrderStartup } from "./OrderStartupBoundary";

const screen = {
  minHeight: "60vh", display: "grid", placeItems: "center", padding: "24px",
  background: "#F9F5EB", color: "#1A1A1A",
};

export function RouteLoading() {
  const startup = useOrderStartup();
  const report = startup?.report;
  const [timedOut, setTimedOut] = useState(false);
  useEffect(() => {
    if (!startup?.active) return undefined;
    const timer = window.setTimeout(() => {
      setTimedOut(true);
      report?.("route", "error");
    }, 15000);
    return () => window.clearTimeout(timer);
  }, [startup?.active, report]);
  if (startup?.visible && !timedOut) return null;
  if (timedOut) return <RouteFailure />;
  return (
    <div style={screen} role="status" aria-live="polite" aria-busy="true">
      <p style={{ margin: 0, fontSize: "16px" }}>Opening your screen…</p>
    </div>
  );
}

function RouteFailure() {
  const report = useOrderStartup()?.report;
  useEffect(() => { report?.("route", "error"); }, [report]);
  return (
    <div style={screen} role="alert">
      <div style={{ maxWidth: 360, textAlign: "center" }}>
        <h1 style={{ color: "var(--cc-text, #3C2415)", fontSize: 22, margin: "0 0 12px" }}>This screen couldn’t open</h1>
        <p style={{ margin: "0 0 20px", lineHeight: 1.5 }}>Check your connection, then reload to try again.</p>
        <button type="button" onClick={() => window.location.reload()} style={{
          border: "1px solid var(--cc-border, #E8DDC8)", borderRadius: 12, padding: "12px 20px",
          minHeight: 48, background: "var(--cc-surface, #FFFFFF)", color: "var(--cc-text, #3C2415)",
          font: "inherit", fontWeight: 600, cursor: "pointer",
        }}>Reload this screen</button>
      </div>
    </div>
  );
}

export default class RouteLoadBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <RouteFailure />;
  }
}
